import React from "react";
import {
    Typography,
    Button,
    Input,
    Avatar,
    Tabs,
    TabsHeader,
    Tab,
    IconButton,
    Tooltip
} from "@material-tailwind/react";
import Swal from "sweetalert2";
import Toaster from "../../components/Toaster";
import { Link, useParams } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Popover } from 'react-tiny-popover';
import { PlusCircleIcon, ShoppingBagIcon } from "@heroicons/react/24/outline";
import ShowLoader from "@/components/Loader";
import useHasPermission from "../../components/useHasPermission";
import { ArrowDownTrayIcon, ChevronDownIcon, EllipsisVerticalIcon, EyeIcon, CheckBadgeIcon, FunnelIcon, MagnifyingGlassIcon, PencilSquareIcon, TrashIcon, XCircleIcon, InformationCircleIcon, ClockIcon, ChatBubbleOvalLeftEllipsisIcon, Bars3BottomLeftIcon, MinusIcon, PlusSmallIcon, PlusIcon, ArrowLeftIcon, DocumentTextIcon } from "@heroicons/react/24/solid";
import { approveRfq, deleteRfq, getRfqById, fetchRFQProduct, sendRfqToAdmin, generateMaterialSubbmital, getRfqMessages, getRfqSummary, sendQuotationToCustomer, sendRfqToManager, salesApproveRfq, procurementApproveRfq, sendRfqToProcurementManager, fetchTimeLine, updateAdminProceed, fetchAssociatedMembers, reassignRfqOrOrder, rejectRfqByProcurement, reforwardToProcurement } from "../../store/slices/rfqSlice";
import ScrollToTop from "@/components/ScrollToTop";
import EditPrice from "@/components/EditPrice";
import RfqSummary from "./rfq-summary";
import RfqItems from "./rfq-items";
import MoveToOrdersModal from "./rfq-modals/move-to-order-modal";
import { useLocation } from "react-router-dom";
import RfqCustomerInfo from "./rfq-customer-info";
import RfqChat from "./rfq-chat";
import AssignTeamMemberModal from "./rfq-modals/assign-team-member-modal";
import RfqDeadlinePopover from "./rfq-deadline-popover";
import MaterialSubmittalModal from "./rfq-modals/material-submittal-modal";
import DocumentViewModal from "@/components/DocumentViewModal";
import RfqPurchaseOrderPopover from "./rfq-purchase-order-popover";
import RfqPaymentReceiptPopover from "./rfq-payment-receipt-popover";
import AssignProcurementModal from "./rfq-modals/assign-rfq-to-procurement-modal";
import EditRFQCommissionDeadline from "./rfq-modals/edit-rfq-commission-deadline-modal";
import moment from "moment";
import TimeLineModal from "./rfq-modals/timeline-modal";
import { useTranslation } from "react-i18next";
import ReassignRfqModal from "./rfq-modals/reassign-rfq-modal";

export function RfqDetails() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation();
    const [search, setSearch] = useState('');
    const { t } = useTranslation('rfq');
    const { t: ct } = useTranslation("common");

    const [activeSection, setActiveSection] = useState("items");
    const [isActionPopoverOpen, setIsActionPopoverOpen] = useState(false);
    const [isAssignTeamModalOpen, setIsAssignTeamModalOpen] = useState(false);
    const [isAssignProcurementModalOpen, setIsAssignProcurementModalOpen] = useState(false);
    const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);

    const [isMoveToOrderModalOpen, setIsMoveToOrderModalOpen] = useState(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isMaterialSubmittalModalOpen, setIsMaterialSubmittalModalOpen] = useState(false);
    const [isEditCommissionModalOpen, setIsEditCommissionModalOpen] = useState(false);

    const [actionMenuOptions, setActionMenuOptions] = useState([]);

    const hasUpdatePermission = useHasPermission(`rfq.update`);
    const hasAddMemberPermission = useHasPermission(`member.add`);

    const { user } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getRfqById(id));
    }, []);

    const { rfq_details, rfq_summary, loading, list_loading } = useSelector((state) => state.rfq);

    useEffect(() => {
        setSearch('');
    }, [activeSection]);

    useEffect(() => {
        if (state && state?.active_tab) {
            setActiveSection(state?.active_tab);
        }

        let options = [];
        const userRole = user?.roles?.[0] || "";

        const adminOptions1 = [
            { label: t("reject_rfq_button"), value: "rejected" },
            { label: t("approve_finalize_rfq_button"), value: "approved" },
        ];
        if ((userRole === "Sub Admin" || userRole === "Administrator") && rfq_details?.is_send_to_admin != null && rfq_details?.admin_approval == null) {
            adminOptions1.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }
        const adminOptions2 = [
            { label: t("commission_deadline_button"), value: "edit_commission" },
            { label: t("reassign_rfq_button"), value: "reassign_rfq" }
        ];
        if (rfq_details?.assigned_details?.length > 0) {
            adminOptions2.forEach((option) => {
                // If the user is Finance, skip adding the 'Commission & Deadline' option
                if (userRole === "Finance" && option.value === "edit_commission") {
                    return;
                }

                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        const salesOptions1 = [
            { label: t("reject_member_submission_button"), value: "sales_rejected" },
            { label: t("approve_member_submission_button"), value: "sales_approved" },
        ];
        if (userRole === "Sales Representative" && user?.parent_id == null &&
            rfq_details?.is_send_to_sales != null && rfq_details?.sales_representative_approval == null) {
            salesOptions1.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }
        const isProcurementAssigned = rfq_details?.assigned_details?.some(
            item => item?.type === "Procurement"
        );
        const isSalesManagerAssigned = rfq_details?.assigned_details?.some(
            item => item?.type === "Sales Representative" && item?.designation?.toLowerCase() === "manager"
        );
        const isSalesMemberAssigned = rfq_details?.assigned_details?.some(
            item => item?.type === "Sales Representative" && item?.designation?.toLowerCase() !== "manager"
        );
        const isSalesAssigned = isSalesManagerAssigned || isSalesMemberAssigned;
        const salesOptions2 = [
            { label: isProcurementAssigned ? t("view_procurement_button") : t("assign_to_procurement_button"), value: "assign_to_procurement" },
        ];

        if (
            (userRole === 'Sales Representative' || userRole === 'Sub Admin' || userRole === 'Administrator') &&
            (isProcurementAssigned || isSalesAssigned)
            &&
            (userRole !== 'Sales Representative' || user?.parent_id == null)
        ) {
            if (user?.parent_id != null) {
                if (rfq_details?.assigned_details?.length > 1) {
                    if (rfq_details?.sales_representative_approval === 'yes') {
                        salesOptions2.forEach(option => {
                            if (!options.some(o => o.value === option.value)) {
                                options.unshift(option);
                            }
                        });
                    }
                } else {
                    salesOptions2.forEach(option => {
                        if (!options.some(o => o.value === option.value)) {
                            options.unshift(option);
                        }
                    });
                }
            } else {
                const isAuthorizedRole = userRole !== 'Sales Representative';
                const hasApprovedAccess = rfq_details?.sales_representative_approval === 'yes';

                if (isAuthorizedRole || isProcurementAssigned || !isSalesMemberAssigned || hasApprovedAccess) {
                    salesOptions2.forEach(option => {
                        if (!options.some(o => o.value === option.value)) {
                            options.unshift(option);
                        }
                    });
                }
            }
        }
        const salesOptions3 = { label: t("send_to_manager_button"), value: "sendToManager" };
        if (userRole === 'Sales Representative' && user?.parent_id !== null && rfq_details?.is_send_to_sales == null) {
            if (!options.some(o => o.value === 'sendToManager')) {
                options.unshift(salesOptions3);
            }
        }

        // const assignedDetails = rfq_details?.assigned_details || [];
        // const isAlreadyAssignedForRole = assignedDetails.some(
        //     (item) => item.type === userRole && item.designation === 'member'
        // );

        // const salesOptions4 = [
        //     { label: t("assign_team_member"), value: "assign" },
        // ];

        // if (
        //     hasAddMemberPermission &&
        //     user?.parent_id == null &&
        //     (userRole === "Sales Representative" ||
        //         userRole === "Procurement") &&
        //     !isAlreadyAssignedForRole
        // ) {
        //     salesOptions4.forEach((option) => {
        //         if (!options.some((o) => o.value === option.value)) {
        //             options.unshift(option);
        //         }
        //     });
        // }

        const assignedDetails = rfq_details?.assigned_details || [];

        const isProcurementRejected = rfq_details?.is_procurement_rejected === 'yes';

        const isDepartmentMemberAssigned = assignedDetails.some(
            (item) =>
                item.type === userRole &&
                item.designation?.toLowerCase() === "member"
        );

        const isManager = user?.parent_id == null || user?.designation?.toLowerCase() === "manager";

        const salesOptions4 = [
            { label: t("assign_team_member"), value: "assign" },
        ];

        if (
            (userRole === "Sales Representative" || userRole === "Procurement") &&
            isManager &&
            hasAddMemberPermission &&
            !isDepartmentMemberAssigned &&
            !isProcurementRejected
        ) {
            salesOptions4.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        // const isProcurementManagerAssigned = assignedDetails.some(
        //     (item) =>
        //         item.type === "Procurement" &&
        //         item.designation?.toLowerCase() === "manager"
        // );

        // const isProcurementMemberAssigned = assignedDetails.some(
        //     (item) =>
        //         item.type === "Procurement" &&
        //         item.designation?.toLowerCase() !== "manager"
        // );

        // const syncProcurementOptions1 = {
        //     label: t("send_to_admin_button"),
        //     value: "sendToAdmin",
        // };

        // if (
        //     userRole?.startsWith("Procurement") &&
        //     rfq_details?.is_send_to_admin == null
        // ) {
        //     let canSendToAdmin = false;

        //     // Manager assigned but no Procurement member assigned
        //     if (
        //         isProcurementManagerAssigned &&
        //         !isProcurementMemberAssigned
        //     ) {
        //         canSendToAdmin = true;
        //     }
        //     // Top-level Procurement user and manager has approved
        //     else if (
        //         user?.parent_id == null &&
        //         rfq_details?.procurement_manager_approval === "yes"
        //     ) {
        //         canSendToAdmin = true;
        //     }

        //     if (
        //         canSendToAdmin &&
        //         !options.some((o) => o.value === "sendToAdmin")
        //     ) {
        //         options.unshift(syncProcurementOptions1);
        //     }
        // }

        const isProcurementManagerAssigned = assignedDetails.some(
            (item) =>
                item.type === "Procurement" &&
                item.designation?.toLowerCase() === "manager"
        );

        const isProcurementMemberAssigned = assignedDetails.some(
            (item) =>
                item.type === "Procurement" &&
                item.designation?.toLowerCase() !== "manager"
        );

        const syncProcurementOptions1 = {
            label: t("send_to_admin_button"),
            value: "sendToAdmin",
        };

        // Match exact App / Flutter Logic for Procurement -> Send to Admin
        if (
            userRole?.startsWith("Procurement") &&
            rfq_details?.is_send_to_admin == null &&
            !isProcurementRejected
        ) {
            let canSendToAdmin = false;

            // 1. If Manager is assigned BUT no Member is assigned -> Manager can directly Send to Admin
            if (isProcurementManagerAssigned && !isProcurementMemberAssigned) {
                canSendToAdmin = true;
            }
            // 2. If Member IS assigned -> Manager (parentId == null) can ONLY Send to Admin AFTER approving Member's work ('yes')
            else if (user?.parent_id == null) {
                if (rfq_details?.procurement_manager_approval === "yes") {
                    canSendToAdmin = true;
                }
            }

            if (
                canSendToAdmin &&
                !options.some((o) => o.value === "sendToAdmin")
            ) {
                options.unshift(syncProcurementOptions1);
            }
        }

        // const isProcurementActive = rfq_details?.is_send_to_procurement != null && rfq_details?.is_procurement_rejected !== 'yes';

        // if (
        //     userRole?.startsWith("Procurement") &&
        //     rfq_details?.is_send_to_admin == null &&
        //     isProcurementActive // Only show if Sales has forwarded/re-forwarded
        // ) {
        //     let canSendToAdmin = false;

        //     if (isProcurementManagerAssigned && !isProcurementMemberAssigned) {
        //         canSendToAdmin = true;
        //     } else if (
        //         user?.parent_id == null &&
        //         rfq_details?.procurement_manager_approval === "yes"
        //     ) {
        //         canSendToAdmin = true;
        //     }

        //     if (canSendToAdmin && !options.some((o) => o.value === "sendToAdmin")) {
        //         options.unshift(syncProcurementOptions1);
        //     }
        // }

        const syncProcurementOptions2 = { label: t("send_to_manager_button"), value: "sendToProcurementManager" };
        if (
            userRole.startsWith('Procurement') &&
            user?.parent_id !== null &&
            user?.designation?.toLowerCase() !== 'manager' && // Ensure sub-members see this, not the manager
            rfq_details?.is_send_to_procurement == null
        ) {
            if (!options.some(o => o.value === 'sendToProcurementManager')) {
                options.unshift(syncProcurementOptions2);
            }
        }

        const syncProcurementOptions3 = [
            { label: t("reject_member_submission_button"), value: "procurement_rejected" },
            { label: t("approve_member_submission_button"), value: "procurement_approved" },
            { label: t('send_back_to_sales'), value: "reject_by_procurement" }
        ];
        if (
            userRole.startsWith('Procurement') &&
            user?.parent_id == null &&
            rfq_details?.is_send_to_procurement != null &&
            rfq_details?.procurement_manager_approval == null
        ) {
            syncProcurementOptions3.forEach((option) => {
                if (!options.some((o) => o.value === option.value)) {
                    options.unshift(option);
                }
            });
        }

        // === ADD THIS NEW OPTION ===
        // Shows "Send Back to Sales" to Procurement Manager before the RFQ is sent to Admin
        if (
            userRole.startsWith('Procurement') &&
            (user?.parent_id == null || user?.designation?.toLowerCase() === 'manager') &&
            rfq_details?.is_send_to_admin == null &&
            rfq_details?.is_procurement_rejected !== 'yes'
        ) {
            if (!options.some(o => o.value === "reject_by_procurement")) {
                options.unshift({
                    label: t('send_back_to_sales'),
                    value: "reject_by_procurement"
                });
            }
        }

        // if (userRole === "Finance" && rfq_details) {
        //     const isProceeding = rfq_details?.is_admin_proceed === "yes";
        //     options.push({
        //         label: isProceeding ? t("admin_proceed_enabled") : t("admin_proceed_disabled"),
        //         value: "toggle_admin_proceed",
        //         current_status: rfq_details?.is_admin_proceed || "no",
        //         isStatusToggle: true,
        //         isActive: isProceeding,
        //         textColor: isProceeding ? "text-green-700 font-semibold" : "text-gray-700 font-medium",
        //         bgHover: isProceeding ? "hover:bg-green-50" : "hover:bg-orange-50"
        //     });
        // }

        const isSalesManager = userRole === "Sales Representative" && user?.parent_id == null;
        const isRfqApprovedBySalesManager = rfq_details?.sales_representative_approval === 'yes' || !isSalesMemberAssigned;
        // const isProcurementRejected = rfq_details?.is_procurement_rejected === 'yes';

        if (isSalesManager && isRfqApprovedBySalesManager && isProcurementRejected
            && 
            (userRole !== 'Sales Representative' || user?.parent_id == null)
        ) {
            if (!options.some((o) => o.value === "reforward_to_procurement")) {
                options.unshift({
                    label: "Reforward to Procurement",
                    value: "reforward_to_procurement",
                });
            }
        }

        setActionMenuOptions(options);

    }, [dispatch, rfq_details, user, t]);

    const handleRejectByProcurement = () => {
        Swal.fire({
            title: t('back_to_sales'),
            text: t('rfq_reason'),
            icon: "warning",
            input: "textarea",
            inputLabel: t('reason'),
            inputPlaceholder: t('rejection_reason'),
            inputAttributes: {
                maxlength: 250,
                autocapitalize: "off",
                autocorrect: "off"
            },
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: t('send_back'),
            cancelButtonText: t('cancel'),
            preConfirm: (reason) => {
                const val = reason?.trim() || "";
                if (!val) {
                    Swal.showValidationMessage(t('reason_required'));
                    return false;
                }
                if (val.length < 3) {
                    Swal.showValidationMessage("Reason must be at least 3 characters.");
                    return false;
                }
                return val;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(rejectRfqByProcurement({ rfq_id: Number(id), reason: result.value }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(res?.message || "RFQ sent back to Sales successfully!");
                            dispatch(getRfqById(id));
                        } else {
                            Toaster.error(res?.message || "Action failed.");
                        }
                    })
                    .catch((error) => {
                        console.error("Rejection failed:", error);
                        Toaster.error(error?.message || "Failed to send RFQ back to Sales.");
                    });
            }
        });
    };

    const handleReforwardToProcurement = () => {
        Swal.fire({
            title: t('reforward_to_procurement'),
            text: t('reforward_confirm'),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#065C36",
            cancelButtonColor: "#d33",
            confirmButtonText: t('reforward'),
            cancelButtonText: t('cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(reforwardToProcurement({ rfq_id: Number(id) }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(res?.message || "RFQ successfully re-forwarded to Procurement.");
                            dispatch(getRfqById(id));
                        } else {
                            Toaster.error(res?.message || "Action failed.");
                        }
                    })
                    .catch((error) => {
                        console.error("Reforward failed:", error);
                        Toaster.error(error?.message || "Failed to reforward RFQ to Procurement.");
                    });
            }
        });
    };

    const handleToggleAdminProceed = async (currentStatus) => {
        const nextStatus = currentStatus === "yes" ? "no" : "yes";
        const confirmationText = nextStatus === "yes"
            ? "Do you want to enable Admin Proceed for this RFQ?"
            : "Do you want to disable Admin Proceed for this RFQ?";

        Swal.fire({
            title: t('are_you_sure'),
            text: confirmationText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(updateAdminProceed({ rfq_id: id, is_admin_proceed: nextStatus }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(t('admin_proceed'));
                            dispatch(getRfqById(id));
                        } else {
                            Toaster.error(res?.message || "Something went wrong.");
                        }
                    })
                    .catch((error) => {
                        console.error("Action failed:", error);
                        Toaster.error(t('proceeding_failed'));
                    });
            }
        });
    };

    const handelSearch = (event) => {
        const value = event.target.value;

        if (event.key === "Enter" && value) {
            onSearch(search);
        } else if (event.key === "Backspace" && value.length === 0) {
            onSearch('');
        }
    }

    const handleSearchClick = () => {
        onSearch(search);
    }

    const handelRemoveSearch = () => {
        setSearch('');
        onSearch('');
    }

    const forceReloadRfqItems = () => {
        setSearch('');
        onSearch('');
        dispatch(getRfqMessages(id));
        dispatch(getRfqById(id));
        dispatch(getRfqSummary(id));
    }

    const onSearch = (search) => {
        dispatch(fetchRFQProduct({ rfq_id: id, search: search }));
    }

    const adminApproveRfq = async (value) => {
        if (rfq_details?.admin_approval === 'yes' && value === 'approved') {
            Toaster.error('This RFQ has already been approved.');
            return;
        }

        var msg = value == 'approved' ? 'approve' : value == 'rejected' ? 'reject' : value;
        let text = `Do you want to ${msg} this RFQ?`;

        Swal.fire({
            title: t('are_you_sure'),
            text: `${text}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(approveRfq({ rfq_id: id, value: value })).unwrap().then((res) => {
                    if (res?.status) {
                        dispatch(getRfqById(id));
                        Toaster.success(`RFQ ${value} successfully!`);
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Changes failed:", error);
                    Toaster.error("Changes failed, please try again.");
                });
            }
        });
    };

    const adminRejectRfq = async (value) => {

        if (rfq_details?.admin_approval === 'yes' && value === 'approved') {
            Toaster.error(t('rfq_already_approved'));
            return;
        }

        const action =
            value === 'approved'
                ? 'approve'
                : value === 'rejected'
                    ? 'reject'
                    : value;

        const translatedMessage = t('rfq_confirmation', {
            action: t(`actions.${action}`),
        });

        Swal.fire({
            title: t('are_you_sure'),
            text: translatedMessage,
            icon: "warning",
            input: "textarea",
            inputPlaceholder: t('reason_placeholder'),
            inputAttributes: {
                maxlength: 50
            },
            showCancelButton: true,
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel'),
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",

            preConfirm: (reason) => {
                if (!reason || !reason.trim()) {
                    Swal.showValidationMessage(t('reason_required'));
                    return false;
                }
                if (reason.length < 5) {
                    Swal.showValidationMessage(t('reason_min'));
                    return false;
                }
                if (reason.length > 50) {
                    Swal.showValidationMessage(t('reason_max'));
                    return false;
                }
                return reason;
            }

        }).then((result) => {

            if (result.isConfirmed) {

                const reason = result.value;

                dispatch(approveRfq({
                    rfq_id: id,
                    value: value,
                    reason: reason
                }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            dispatch(getRfqById(id));
                            Toaster.success(t('rfq_admin_reject', { value: value }));
                        } else {
                            Toaster.error(res?.message);
                        }
                    })
                    .catch((error) => {
                        console.error("Changes failed:", error);
                        Toaster.error(t('reason_error'));
                    });
            }
        });
    };

    // const salesApproveRejectRfq = async (value) => {
    //     if (rfq_details?.sales_representative_approval === 'yes' && value === 'approved') {
    //         Toaster.error('This RFQ has already been approved.');
    //         return;
    //     }

    //     var msg = value == 'approved' ? 'approve' : value == 'rejected' ? 'reject' : value;
    //     let text = `Do you want to ${msg} this RFQ?`;

    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: `${text}`,
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: "Yes"
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             dispatch(salesApproveRfq({ rfq_id: id, status: value })).unwrap().then((res) => {
    //                 if (res?.status) {
    //                     dispatch(getRfqById(id));
    //                     Toaster.success(`RFQ ${value} successfully!`);
    //                 } else {
    //                     Toaster.error(res?.message);
    //                 }
    //             }).catch((error) => {
    //                 console.error("Changes failed:", error);
    //                 Toaster.error("Changes failed, please try again.");
    //             });
    //         }
    //     });
    // };

    const salesApproveRejectRfq = async (value) => {
        if (rfq_details?.sales_representative_approval === 'yes' && value === 'approved') {
            Toaster.error(t('rfq_already_approved'));
            return;
        }

        const msg = value === 'approved' ? 'approve' : 'reject';

        if (value === 'rejected') {
            Swal.fire({
                title: t('rfq_rejected'),
                text: t("rfq_rejection_reason_required"),
                icon: "warning",
                input: "textarea",
                inputLabel: t("reason"),
                inputPlaceholder: t("rejection_reason"),
                inputAttributes: {
                    maxlength: 100,
                    autocapitalize: "off",
                    autocorrect: "off"
                },
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t('reject'),
                cancelButtonText: t('cancel'),
                preConfirm: (reason) => {
                    const value = reason?.trim() || "";

                    if (!value) {
                        Swal.showValidationMessage("Reason is required.");
                        return false;
                    }

                    if (value.length < 3) {
                        Swal.showValidationMessage("Reason must be at least 3 characters.");
                        return false;
                    }

                    if (value.length > 100) {
                        Swal.showValidationMessage("Reason cannot exceed 100 characters.");
                        return false;
                    }

                    return value;
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        salesApproveRfq({
                            rfq_id: id,
                            status: value,
                            reason: result.value
                        })
                    )
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                dispatch(getRfqById(id));
                                Toaster.success(`RFQ ${value} successfully!`);
                            } else {
                                Toaster.error(res?.message);
                            }
                        })
                        .catch((error) => {
                            console.error("Changes failed:", error);
                            Toaster.error("Changes failed, please try again.");
                        });
                }
            });

            return;
        }

        // Existing approve flow remains unchanged
        Swal.fire({
            title: t('are_you_sure'),
            text: t("approve_rfq_confirmation"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    salesApproveRfq({
                        rfq_id: id,
                        status: value
                    })
                )
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            dispatch(getRfqById(id));
                            Toaster.success(`RFQ ${value} successfully!`);
                        } else {
                            Toaster.error(res?.message);
                        }
                    })
                    .catch((error) => {
                        console.error("Changes failed:", error);
                        Toaster.error("Changes failed, please try again.");
                    });
            }
        });
    };

    const procurementApproveRejectRfq = async (value) => {
        if (rfq_details?.procurement_manager_approval === 'yes' && value === 'approved') {
            Toaster.error('This RFQ has already been approved.');
            return;
        }

        if (value === "rejected") {
            Swal.fire({
                title: t("rfq_rejected"),
                text: t("rfq_rejection_reason_required"),
                icon: "warning",
                input: "textarea",
                inputLabel: t("reason"),
                inputPlaceholder: t("rejection_reason"),
                inputAttributes: {
                    maxlength: 100,
                    autocapitalize: "off",
                    autocorrect: "off",
                },
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: t('reject'),
                cancelButtonText: t('cancel'),
                preConfirm: (reason) => {
                    const value = reason?.trim() || "";

                    if (!value) {
                        Swal.showValidationMessage("Reason is required.");
                        return false;
                    }

                    if (value.length < 3) {
                        Swal.showValidationMessage("Reason must be at least 3 characters.");
                        return false;
                    }

                    if (value.length > 100) {
                        Swal.showValidationMessage("Reason cannot exceed 100 characters.");
                        return false;
                    }

                    return value;
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        procurementApproveRfq({
                            rfq_id: id,
                            status: value,
                            reason: result.value,
                        })
                    )
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                dispatch(getRfqById(id));
                                Toaster.success(`RFQ ${value} successfully!`);
                            } else {
                                Toaster.error(res?.message);
                            }
                        })
                        .catch((error) => {
                            console.error("Changes failed:", error);
                            Toaster.error("Changes failed, please try again.");
                        });
                }
            });

            return;
        }

        var msg = value == 'approved' ? 'approve' : value == 'rejected' ? 'reject' : value;
        let text = `Do you want to ${msg} this RFQ?`;

        Swal.fire({
            title: t('are_you_sure'),
            text: `${text}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(procurementApproveRfq({ rfq_id: id, status: value })).unwrap().then((res) => {
                    if (res?.status) {
                        dispatch(getRfqById(id));
                        Toaster.success(`RFQ ${value} successfully!`);
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Changes failed:", error);
                    Toaster.error("Changes failed, please try again.");
                });
            }
        });
    };

    const downloadMaterialSubmittal = () => {
        dispatch(generateMaterialSubbmital({ rfq_id: id })).unwrap().then((res) => {
            if (res?.status) {
                Toaster.success(`Material subbmital generated successfully!`);
                const link = document.createElement("a");
                link.target = "_blank";
                link.href = res?.data?.url;
                link.download = res?.data?.file_name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                Toaster.error("Something went wrong, please try again.");
            }
        }).catch((error) => {
            Toaster.error("Failed to generate material subbmital, please try again.");
        });
    }

    const rfqSendToAdmin = () => {
        if (rfq_details?.is_send_to_admin !== null && rfq_details?.admin_approval === 'no') {
            Toaster.error(t('rfq_already_submitted'));
            return;
        }
        if (rfq_details?.is_send_to_admin !== null && rfq_details?.admin_approval === 'yes') {
            Toaster.error(t('rfq_approved'));
            return;
        }
        Swal.fire({
            title: t('are_you_sure'),
            text: t('send_to_admin'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes_send'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(sendRfqToAdmin({ rfq_id: id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(t('rfq_sent'));
                        dispatch(getRfqById(id));
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Sending failed:", error);
                    Toaster.error(t('rfq_failed'));
                });
            }
        });
    }
    const rfqSendToManager = () => {
        if (rfq_details?.is_send_to_sales !== null && rfq_details?.sales_representative_approval === 'no') {
            Toaster.error(t('rfq_already_submt_manager'));
            return;
        }
        if (rfq_details?.is_send_to_sales !== null && rfq_details?.sales_representative_approval === 'yes') {
            Toaster.error(t('rfq_approved_manager'));
            return;
        }
        Swal.fire({
            title: t('are_you_sure'),
            text: t('send_to_manager'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes_send'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(sendRfqToManager({ rfq_id: id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(t('rfq_sent_manager'));
                        dispatch(getRfqById(id));
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Sending failed:", error);
                    Toaster.error(t('rfq_failed'));
                });
            }
        });
    }

    const rfqSendToProcurementManager = () => {
        if (rfq_details?.is_send_to_procurement !== null && rfq_details?.is_send_to_procurement === 'no') {
            Toaster.error(t('rfq_already_submitted_manager'));
            return;
        }
        if (rfq_details?.procurement_manager_approval !== null && rfq_details?.procurement_manager_approval === 'yes') {
            Toaster.error(t('rfq_approved_manager'));
            return;
        }
        Swal.fire({
            title: t('are_you_sure'),
            text: t('send_to_manager'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes_send'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(sendRfqToProcurementManager({ rfq_id: id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(t('rfq_sent_manager'));
                        dispatch(getRfqById(id));
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Sending failed:", error);
                    Toaster.error(t('rfq_failed'));
                });
            }
        });
    }

    const priorityColorMap = {
        high: "bg-red-500",
        medium: "bg-yellow-500",
        low: "bg-green-500",
    };

    const sendQuotationToClient = () => {
        const isMaterialSubmittalRequested = rfq_details?.material_submittal === 'yes';
        const totalAmount = Number(rfq_summary?.payableAmount?.toString().replace(/,/g, '') ?? 0);
        const PRIMARY_COLOR = "#065C36";
        const CANCEL_COLOR = "#F44336";
        Swal.fire({
            title: `<span class="text-xl font-bold text-gray-800">${t('finalize_quotation_title')}</span>`,
            html: `
            <style>
            .swal2-styled.swal2-confirm {
                background-color: ${PRIMARY_COLOR} !important;
                color: white !important;
                box-shadow: none !important;
            }
            .swal2-styled.swal2-cancel {
                background-color: ${CANCEL_COLOR} !important;
                color: white !important;
                box-shadow: none !important;
            }
            .swal2-styled.swal2-confirm:hover {
                background-color: ${PRIMARY_COLOR} !important;
                filter: brightness(95%);    
            }
            </style>
        <div class="mt-4 text-left border-t border-gray-100 pt-4">
            <div class="bg-[#065C36] text-white p-5 rounded-2xl mb-6 shadow-lg relative overflow-hidden">
                <div class="relative z-10">
                    <p class="text-xs uppercase tracking-widest text-gray-400 font-medium mb-1">${t('total_quotation_value_label')}</p>
                    <p class="text-3xl font-bold">${rfq_summary?.currency_code} ${totalAmount.toFixed(2)}</p>
                </div>
            </div>
            <div class="space-y-5">
                <div>
                    <label class="block text-xs font-bold uppercase text-gray-500 mb-2 ml-1 tracking-wide">
                        ${t('credit_date_label')}
                    </label>
                    <input
                        id="credit-date"
                        type="date"
                        class="w-full px-4 py-4 text-lg font-semibold rounded-xl border-2 border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-500/10 outline-none transition-all shadow-sm"
                    />
                </div>
                <div>
                    <label class="block text-xs font-bold uppercase text-gray-500 mb-2 ml-1 tracking-wide">
                        ${t('initial_payment_amount_label', {
                currency: rfq_summary?.currency_code
            })}
                    </label>
                    <input
                        id="paid-amount"
                        type="number"
                        class="w-full px-4 py-4 text-xl font-bold rounded-xl border-2 border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-500/10 outline-none transition-all shadow-sm"
                        value=${totalAmount.toFixed(2)}
                        min="0"
                        max=${totalAmount}
                        step="0.01"
                        placeholder="${t('enter_amount_placeholder')}"
                    />
                </div>
                <div>
                    <label class="block text-xs font-bold uppercase text-gray-500 mb-2 ml-1 tracking-wide">
                        ${t('notes_label')}
                    </label>
                    <textarea
                        id="quotation-notes"
                        rows="4"
                        minlength="5"
                        maxlength="250"
                        placeholder="${t('enter_notes_placeholder')}"
                        class="w-full px-4 py-3 text-sm rounded-xl border-2 border-gray-200 focus:border-green-500 focus:ring-4 focus:ring-green-500/10 outline-none transition-all shadow-sm resize-none"
                    ></textarea>
                    <div class="flex justify-between mt-1 px-1">
                        <p class="text-[11px] text-gray-400">${t('min_chars_note')}</p>
                        <p id="notes-count" class="text-[11px] text-gray-400">0 / 250</p>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-3 text-center">
                    <div class="p-4 bg-gray-50 rounded-xl border border-gray-100">
                        <p class="text-[10px] uppercase text-gray-400 font-black mb-1">${t('initial_payment_percentage_label')}</p>
                        <p id="display-percent" class="text-lg font-bold text-green-600">100.00%</p>
                    </div>
                    <div class="p-4 bg-gray-50 rounded-xl border border-gray-100">
                        <p class="text-[10px] uppercase text-gray-400 font-black mb-1">${t('pending_payment_label')}</p>
                        <p id="display-due" class="text-lg font-bold text-red-500">${rfq_summary?.currency_code} 0.00</p>
                    </div>
                </div>
            </div>
            <p class="text-center text-gray-400 text-[11px] mt-6">${t('validation_note')}</p>
            ${isMaterialSubmittalRequested ? `
                <div class="mt-5 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                    <label class="flex items-start gap-3 cursor-pointer">
                        <input type="checkbox" id="attach-submittal" class="mt-1 w-4 h-4 accent-[#065C36]" checked />
                        <div>
                            <p class="text-sm font-semibold text-gray-800">${t('material_submittal_requested_label')}</p>
                            <p class="text-xs text-gray-500">${t('material_submittal_requested_desc')}</p>
                        </div>
                    </label>
                </div>
            ` : ""}
        </div>
        `,
            showCancelButton: true,
            confirmButtonText: t('confirm_and_send_button'),
            cancelButtonText: ct('cancel'),
            confirmButtonColor: "#065C36",
            cancelButtonColor: "#F44336",
            customClass: {
                popup: 'rounded-3xl shadow-2xl',
                confirmButton: 'rounded-xl px-8 py-3 font-bold text-white',
                cancelButton: 'rounded-xl px-8 py-3 font-bold'
            },
            didOpen: () => {
                const popup = Swal.getPopup();
                const input = popup.querySelector("#paid-amount");
                const pText = popup.querySelector("#display-percent");
                const dText = popup.querySelector("#display-due");
                const creditInput = popup.querySelector("#credit-date");
                const notesInput = popup.querySelector("#quotation-notes");
                const notesCount = popup.querySelector("#notes-count");

                if (notesInput && notesCount) {
                    notesInput.addEventListener("input", () => {
                        notesCount.innerText = `${notesInput.value.length} / 250`;
                    });
                }
                const today = new Date().toISOString().split("T")[0];
                if (creditInput) creditInput.setAttribute("min", today);

                input.addEventListener("input", () => {
                    const rawValue = input.value;
                    if (rawValue === "") {
                        pText.innerText = "0.00%";
                        dText.innerText = `${rfq_summary?.currency_code} ${Number(totalAmount).toFixed(2)}`;
                        dText.className = "text-lg font-bold text-red-500";
                        return;
                    }
                    let val = parseFloat(rawValue);
                    if (isNaN(val)) val = 0;
                    if (val > totalAmount) {
                        val = totalAmount;
                        input.value = totalAmount;
                    }
                    if (val < 0) {
                        val = 0;
                        input.value = 0;
                    }
                    const pct = totalAmount > 0 ? ((val / totalAmount) * 100).toFixed(2) : "0.00";
                    const due = (totalAmount - val).toFixed(2);
                    pText.innerText = `${pct}%`;
                    dText.innerText = `${rfq_summary?.currency_code} ${Number(due).toFixed(2)}`;
                    dText.className = val >= totalAmount ? "text-lg font-bold text-green-600" : "text-lg font-bold text-red-500";
                });
                input.addEventListener("keyup", () => {
                    if (input.value.trim() === "") {
                        input.value = 0;
                        pText.innerText = "0.00%";
                        dText.innerText = `${rfq_summary?.currency_code} ${Number(totalAmount).toFixed(2)}`;
                        dText.className = "text-lg font-bold text-red-500";
                    } else if (/^0\d+/.test(input.value)) {
                        input.value = parseFloat(input.value);
                    }
                });
            },
            preConfirm: () => {
                const paid = Number(document.getElementById("paid-amount").value);
                const due = Number((totalAmount - paid).toFixed(2));
                const pct = totalAmount > 0 ? Number(((paid / totalAmount) * 100).toFixed(2)) : 0;
                const attachSubmittal = document.getElementById("attach-submittal")?.checked || false;
                const creditDate = document.getElementById("credit-date").value;
                const today = new Date().toISOString().split("T")[0];
                const notes = document.getElementById("quotation-notes").value.trim();

                if (paid < 0) {
                    Swal.showValidationMessage(t('invalid_payment_amount_error'));
                    return false;
                }
                if (creditDate && creditDate < today) {
                    Swal.showValidationMessage(t('future_dates_only_error'));
                    return false;
                }
                if (notes && notes.length < 5) {
                    Swal.showValidationMessage(t('notes_min_chars_error'));
                    return false;
                }
                if (notes.length > 250) {
                    Swal.showValidationMessage(t('notes_max_chars_error'));
                    return false;
                }
                return { total_amount: totalAmount, paid_amount: paid, due_amount: due, percentage: pct, attach_submittal: attachSubmittal, credit_date: creditDate, notes };
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const { total_amount, paid_amount, due_amount, percentage, attach_submittal, credit_date, notes } = result.value;
                dispatch(sendQuotationToCustomer({ rfq_id: id, total_amount, paid_amount, due_amount, percentage, attach_submittal, credit_date, notes }))
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(t('quotation_sent_success'));
                            dispatch(getRfqById(id));
                            dispatch(getRfqMessages(id));
                        } else {
                            Toaster.error(res?.message || t('quotation_sent_error'));
                        }
                    })
                    .catch(() => {
                        Toaster.error(t('quotation_sent_comm_error'));
                    });
            }
        });
    };

    const sendMaterialSubmittalToClient = () => {
        Swal.fire({
            title: t('are_you_sure'),
            text: 'Do you really want to send the material submittal to the customer?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('yes_send'),
            cancelButtonText: t('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(generateMaterialSubbmital({ rfq_id: id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(`Material submittal sent successfully!`);
                    } else {
                        Toaster.error(res?.message);
                    }
                }).catch((error) => {
                    console.error("Sending failed:", error);
                    Toaster.error("Sending failed, please try again.");
                });
            }
        });
    }

    const [timelineData, setTimelineData] = useState([]);
    const [timelineLoading, setTimelineLoading] = useState(false);

    useEffect(() => {
        if (id) {
            dispatch(getRfqById(id));
            setTimelineLoading(true);
            dispatch(fetchTimeLine(id)).unwrap()
                .then((res) => {
                    const data = res?.data || (Array.isArray(res) ? res : []);
                    setTimelineData(data);
                    setTimelineLoading(false);
                })
                .catch((err) => {
                    console.error("Timeline fetch error:", err);
                    setTimelineLoading(false);
                });
        }
    }, [id, dispatch]);

    const latestTimeline = timelineData.length > 0 ? timelineData[timelineData.length - 1] : null;
    const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);

    const userRoleString = user?.roles?.[0] || "";
    const isProcurementUser = userRoleString.startsWith("Procurement");

    return (
        <div className="mt-5 mb-8 flex flex-col gap-8">
            {loading && <ShowLoader />}
            <ScrollToTop />
            <div className="flex flex-col md:flex-row justify-between items-start gap-4 md:gap-0 px-4 md:px-6 overflow-x-auto whitespace-nowrap">
                <div className="flex w-full md:flex-1">
                    <div className="flex items-center gap-3 min-w-[250px]">
                        <Link onClick={() => navigate(-1)} className="flex items-center text-blue-600 hover:text-blue-800">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </Link>
                        <div>
                            <div className="flex items-center gap-2">
                                {rfq_details?.assigned_details?.[0]?.priority && (
                                    <span className={`w-2 h-2 rounded-full ${priorityColorMap[rfq_details.assigned_details[0].priority]}`}></span>
                                )}
                                <Typography variant="h5" color="blue-gray">
                                    {t("rfq_id_prefix")} {String(id).padStart(4, "0")}
                                </Typography>
                            </div>
                            <p className="text-sm text-gray-500">{t("ref_id_prefix")} {rfq_details?.rfq_reference}</p>
                        </div>
                        <span className="cursor-pointer shrink-0" onClick={() => forceReloadRfqItems()}>
                            <img src={`/img/icons/reload.png`} alt='Reload' className={`h-4 w-4 object-contain mt-1 ${list_loading ? "animate-spin" : ""}`} />
                        </span>
                    </div>
                </div>

                <div className="flex items-center gap-3 pl-0 sm:pl-4 pr-4 md:px-6 pb-2">
                    {timelineLoading ? (
                        <div className="animate-pulse flex items-center gap-3 bg-gray-50 rounded-lg px-4 py-2">
                            <div className="rounded-full bg-slate-200 h-8 w-8"></div>
                            <div className="flex-1 space-y-2 py-1">
                                <div className="h-2 bg-slate-200 rounded w-24"></div>
                                <div className="h-2 bg-slate-200 rounded w-48"></div>
                            </div>
                        </div>
                    ) : latestTimeline ? (
                        <div onClick={() => setIsTimelineModalOpen(true)} className="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-lg px-4 py-2 shadow-sm cursor-pointer hover:bg-blue-100 transition-colors group max-w-[75vw] lg:max-w-[30vw] xl:max-w-[20vw]">
                            <div className="bg-blue-500 p-1.5 rounded-full flex-shrink-0 group-hover:scale-110 transition-transform">
                                <ClockIcon className="h-4 w-4 text-white" />
                            </div>
                            <div className="flex flex-col min-w-0">
                                <span className="text-[10px] uppercase tracking-wider text-blue-600 font-bold">{t("status_label")}</span>
                                <div className="flex items-center gap-1.5 min-w-0">
                                    <Typography className="text-sm font-semibold text-gray-900 truncate max-w-[300px]">{latestTimeline.message}</Typography>
                                    <span className="text-gray-400 text-xs flex-shrink-0">•</span>
                                    <span className="text-xs text-gray-500 font-medium flex-shrink-0">
                                        {latestTimeline.date_time ? moment(latestTimeline.date_time).format("D MMM, h:mm A") : "N/A"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-lg px-4 py-2">
                            <InformationCircleIcon className="h-4 w-4 text-gray-400" />
                            <span className="text-xs text-gray-400 italic">No activity history found for this RFQ.</span>
                        </div>
                    )}
                </div>

                {activeSection === "items" && <div className="w-full md:flex-1 flex justify-start">
                    <div className="w-full max-w-md relative">
                        <Input className={search ? "ltr:pr-10 rtl:pl-10" : ""} label={ct("search")} value={search} onChange={(e) => setSearch(e.target.value)} onKeyUp={handelSearch} />
                        {!search && (
                            <MagnifyingGlassIcon
                                aria-hidden="true"
                                className="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-blue-gray-500 ltr:right-3 rtl:left-3"
                            />
                        )}
                        {search && (
                            <IconButton variant="text" size="sm" className="!absolute top-1 ltr:right-1 rtl:left-1" onClick={handelRemoveSearch}>
                                <XCircleIcon className="h-5 w-5 text-red-500" />
                            </IconButton>
                        )}
                    </div>
                    {search && (<Button variant="outlined" className="flex items-center border-gray-300 capitalize font-bold bg-black text-white mx-2" onClick={handleSearchClick}><MagnifyingGlassIcon className="w-4 h-4 mr-1" /> {t("search_button")}</Button>)}
                </div>}

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pl-0 sm:pl-4 md:pl-6 h-10">
                    {(hasUpdatePermission && user?.parent_id == null && (userRoleString === 'Administrator' || userRoleString === 'Sub Admin')) && (
                        <Button
                            variant="outlined"
                            className={`flex items-center gap-2 border-gray-300 capitalize font-bold ${rfq_details?.admin_approval !== 'yes' ? 'bg-gray-800' : 'bg-[#065C36]'} text-white`}
                            onClick={() => sendQuotationToClient()}
                            disabled={rfq_details?.admin_approval !== 'yes' || rfq_details?.is_po_approved === 'yes'}
                        >
                            {t("send_quotation_to_client_button")} {rfq_details?.quotation_count > 0 ? ` (${rfq_details.quotation_count})` : ""}
                        </Button>
                    )}

                    {rfq_details && rfq_details?.assigned_details !== null && rfq_details?.is_send_to_admin === null && rfq_details?.admin_approval !== "yes" && (userRoleString === 'Sales Representative' || isProcurementUser) && (
                        <RfqDeadlinePopover rfq_data={rfq_details} />
                    )}

                    {rfq_details && (userRoleString === "Administrator" || userRoleString === "Sub Admin") && rfq_details?.is_po_approved === 'yes' && (rfq_details?.customer_approval !== "no" || (rfq_details?.admin_approval !== null && rfq_details?.is_send_to_admin !== null && rfq_details?.customer_approval === "yes")) && (
                        <Button variant="outlined" className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-[#065C36] text-white" onClick={() => setIsMoveToOrderModalOpen(true)}>
                            {t("approve_assign_to_finance_button")}
                        </Button>
                    )}
                </div>
            </div>

            <div className="flex flex-col lg:flex-row justify-between items-start gap-4 px-4 md:px-6 overflow-x-auto">
                <div className="flex items-center gap-2 whitespace-nowrap">
                    <button onClick={() => setActiveSection("items")} className={`flex items-center gap-2 px-4 py-2.5 rounded-full transition-all shadow-sm ${activeSection === "items" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:text-gray-900"}`}>
                        <ShoppingBagIcon className="h-4 w-4 text-gray-600" />
                        <span className="text-sm font-medium">{t("items_quotation_tab")}</span>
                    </button>
                    <button onClick={() => setActiveSection("chat")} className={`flex items-center gap-2 px-4 py-2.5 rounded-full transition-all shadow-sm ${activeSection === "chat" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:text-gray-900"}`}>
                        <ChatBubbleOvalLeftEllipsisIcon className="h-4 w-4 text-gray-600" />
                        <span className="text-sm font-medium">{t("chat_tab")}</span>
                    </button>
                    <button onClick={() => setActiveSection("customer")} className={`flex items-center gap-2 px-4 py-2.5 rounded-full transition-all shadow-sm ${activeSection === "customer" ? "bg-black text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:text-gray-900"}`}>
                        <InformationCircleIcon className="h-4 w-4 text-gray-600" />
                        <span className="text-sm font-medium">{t("customer_info_tab")}</span>
                    </button>
                    <RfqPurchaseOrderPopover purchase_order_data={rfq_details?.purchase_order_file} all_purchase_orders={rfq_details?.purchase_orders} buttonText={t("purchase_orders_button")} />
                    <RfqPaymentReceiptPopover rfq_id={id} receipts={rfq_details?.payment} payment_summary={rfq_details?.payment_summary} rfq_details={rfq_details} buttonText={t("payment_receipts_button")} />
                </div>

                {/* SAFE VISIBILITY LAYER FOR PROCUREMENT USERS WITHOUT REQUIRING GENERAL UPDATE PERMISSIONS */}
                {((hasUpdatePermission && actionMenuOptions.length > 0) || userRoleString === "Finance" || isProcurementUser) && (
                    <div className="flex items-center gap-2 md:gap-3">
                        <Popover
                            isOpen={isActionPopoverOpen}
                            positions={["bottom", "right"]}
                            padding={4}
                            align="start"
                            onClickOutside={() => setIsActionPopoverOpen(false)}
                            content={
                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                    {actionMenuOptions.map((option) => (
                                        <button
                                            key={option.value}
                                            onClick={() => {
                                                setIsActionPopoverOpen(false);
                                                if (option.value === "toggle_admin_proceed") handleToggleAdminProceed(option.current_status);
                                                if (option.value === "assign") {
                                                    if (rfq_details?.customer_approval === 'yes') {
                                                        Toaster.error('This quotation has already been approved by the customer.');
                                                    } else {
                                                        setIsAssignTeamModalOpen(true);
                                                    }
                                                }
                                                if (option.value === "approved") adminApproveRfq('approved');
                                                if (option.value === "rejected") adminRejectRfq('rejected');
                                                if (option.value === "sales_approved") salesApproveRejectRfq('approved');
                                                if (option.value === "sales_rejected") salesApproveRejectRfq('rejected');
                                                if (option.value === 'procurement_approved') procurementApproveRejectRfq('approved');
                                                if (option.value === 'procurement_rejected') procurementApproveRejectRfq('rejected');
                                                if (option.value === "sendToAdmin") rfqSendToAdmin();
                                                if (option.value === "sendToManager") rfqSendToManager();
                                                if (option.value === "sendToProcurementManager") rfqSendToProcurementManager();
                                                if (option.value === "assign_to_procurement") setIsAssignProcurementModalOpen(true);
                                                if (option.value === "edit_commission") setIsEditCommissionModalOpen(true);
                                                if (option.value === "send_material_submittal") sendMaterialSubmittalToClient();
                                                if (option.value === "reassign_rfq") setIsReassignModalOpen(true);
                                                if (option.value === "reject_by_procurement") handleRejectByProcurement();
                                                if (option.value === "reforward_to_procurement") handleReforwardToProcurement();
                                            }}
                                            className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                        >
                                            {option.label}
                                            {(option.value === "send_material_submittal" && !rfq_details?.final_uploaded_submittal) && <span className="w-2 h-2 bg-red-500 rounded-full"></span>}
                                            {(option.value === "send_material_submittal" && rfq_details?.final_uploaded_submittal) && <span className="w-2 h-2 bg-green-500 rounded-full"></span>}
                                        </button>
                                    ))}
                                </div>
                            }
                        >
                            <button
                                onClick={() => setIsActionPopoverOpen(!isActionPopoverOpen)}
                                className="flex items-center justify-between w-28 gap-2 px-4 py-2.5 rounded-lg bg-yellow-700 text-gray-900 font-medium hover:bg-yellow-800 transition-all shadow-sm"
                            >
                                <span className="text-sm">{t("action_label")}</span>
                                <ChevronDownIcon className="w-4 h-4" />
                            </button>
                        </Popover>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-full">
                <div className="pr-1 overflow-x-auto">
                    {activeSection === "items" && <RfqItems rfq_id={id} rfq_data={rfq_details} search={search} />}
                    {activeSection === "chat" && <RfqChat rfq_id={id} customer_id={rfq_details?.user_id} purchase_order={rfq_details?.purchase_order_file} />}
                    {activeSection === "customer" && <RfqCustomerInfo rfq_id={id} />}
                </div>
                <div className="pl-0 md:pl-5">
                    <RfqSummary rfq_id={id} search={search} />
                </div>
            </div>

            {isAssignProcurementModalOpen && <AssignProcurementModal isOpen={isAssignProcurementModalOpen} onClose={() => setIsAssignProcurementModalOpen(false)} rfqId={id} assigned_details={rfq_details?.assigned_details} />}
            {isEditCommissionModalOpen && <EditRFQCommissionDeadline isOpen={isEditCommissionModalOpen} onClose={() => setIsEditCommissionModalOpen(false)} rfqId={id} assigned_details={rfq_details?.assigned_details} />}
            {isAssignModalOpen && <AssignSalesManagerModal onClose={() => setIsAssignModalOpen(false)} />}
            {isMoveToOrderModalOpen && <MoveToOrdersModal isOpen={isMoveToOrderModalOpen} onClose={() => setIsMoveToOrderModalOpen(false)} rfq_id={id} customer_uploaded_po={rfq_details?.purchase_order_file} />}
            {isAssignTeamModalOpen && <AssignTeamMemberModal isOpen={isAssignTeamModalOpen} onClose={() => setIsAssignTeamModalOpen(false)} rfq_id={id} assigned_details={rfq_details?.assigned_details} />}
            {isMaterialSubmittalModalOpen && <MaterialSubmittalModal isOpen={isMaterialSubmittalModalOpen} onClose={() => setIsMaterialSubmittalModalOpen(false)} rfq_id={id} />}
            {isTimelineModalOpen && <TimeLineModal onClose={() => setIsTimelineModalOpen(false)} rfqId={id} />}
            {isReassignModalOpen && <ReassignRfqModal isOpen={isReassignModalOpen} onClose={() => { setIsReassignModalOpen(false); dispatch(getRfqById(id)); }} rfqId={id} />}
        </div>
    );
}

export default RfqDetails;
